import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-328198e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_Transition, {
          name: "fade-transform",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_KeepAlive, { include: _ctx.cachedViews }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                class: "app-container",
                key: _ctx.key
              }))
            ], 1032, ["include"]))
          ]),
          _: 2
        }, 1024)
      ])
    ]),
    _: 1
  }))
}